import {
	RESET_STATE,
	SET_TYPES,
	SET_IS_TYPES_LOADING,
	SET_GROUPS_LIST,
	SET_IS_GROUPS_LIST_LOADING,
	SET_MODES,
	SET_IS_MODES_LOADING,
	SET_WAYS_LIST,
	SET_IS_WAYS_LIST_LOADING,
	SET_COLLECTION_GROUP_LIST,
	SET_IS_COLLECTION_GROUP_LIST_LOADING,
	RESET_IS_COLLECTION_GROUP_LIST_LOADING,
	SET_COLLECTION_WAY_LIST,
	SET_IS_COLLECTION_WAY_LIST_LOADING,
	RESET_IS_COLLECTION_WAY_LIST_LOADING,
	SET_ORDERS_COLLECTION_GROUP_LIST,
	SET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING,
	RESET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING,
	SET_ORDERS_COLLECTION_WAY_LIST,
	SET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING,
	RESET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING,
	SET_IS_LOADING,
	SET_WAYS_GROUP_LIST,
	SET_IS_WAYS_GROUP_LIST_LOADING,
	RESET_IS_WAYS_GROUP_LIST_LOADING,
	SET_GROUP_OPEN,
	SET_WAY_OPEN,
	SET_GROUP_WAY_OPEN,
	SET_COLLECTION_WAY_OPEN,
	SET_COLLECTION_GROUP_OPEN,
	SET_GROUPS_WITH_WAYS_LIST,
	SET_IS_GROUPS_WITH_WAYS_LIST_LOADING,
} from './actions';

export const initialState = {
	groupsList: null,
	groupsWithWaysList: null,
	isGroupsListLoading: false,
	isGroupsWithWaysListLoading: false,
	waysList: null,
	isWaysListLoading: false,
	types: null,
	isTypesLoading: false,
	pagination: null,
	paginationWays: null,
	collectionGroupList: {},
	collectionGroupCount: {},
	isCollectionGroupListLoading: [],
	collectionWayList: {},
	isCollectionWayListLoading: [],
	ordersCollectionGroupList: {},
	ordersCollectionGroupCount: {},
	isOrdersCollectionGroupListLoading: [],
	ordersCollectionWayList: {},
	isOrdersCollectionWayListLoading: [],
	waysGroupList: {},
	isWaysGroupListLoading: [],
	modes: null,
	isModesLoading: false,
	isLoading: false,
	groupOpen: null,
	collectionGroupOpen: null,
	groupWayOpen: null,
	wayOpen: null,
	collectionWayOpen: null,
};

const orderGroupsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case SET_GROUPS_LIST:
			return {
				...state,
				groupsList: payload,
			};
		case SET_GROUPS_WITH_WAYS_LIST:
			return {
				...state,
				groupsWithWaysList: payload,
			};
		case SET_IS_GROUPS_LIST_LOADING:
			return {
				...state,
				isGroupsListLoading: payload,
			};
		case SET_IS_GROUPS_WITH_WAYS_LIST_LOADING:
			return {
				...state,
				isGroupsWithWaysListLoading: payload,
			};
		case SET_WAYS_LIST:
			return {
				...state,
				waysList: payload,
			};
		case SET_IS_WAYS_LIST_LOADING:
			return {
				...state,
				isWaysListLoading: payload,
			};
		case SET_TYPES:
			return {
				...state,
				types: payload,
			};
		case SET_IS_TYPES_LOADING:
			return {
				...state,
				isTypesLoading: payload,
			};
		case SET_COLLECTION_GROUP_LIST:
			return {
				...state,
				collectionGroupList: payload,
			};
		case SET_IS_COLLECTION_GROUP_LIST_LOADING:
			return { ...state, isCollectionGroupListLoading: [...state.isCollectionGroupListLoading, action.payload] };
		case RESET_IS_COLLECTION_GROUP_LIST_LOADING:
			return {
				...state,
				isCollectionGroupListLoading: state.isCollectionGroupListLoading.filter(el => el !== action.payload),
			};
		case SET_COLLECTION_WAY_LIST:
			return {
				...state,
				collectionWayList: payload,
			};
		case SET_IS_COLLECTION_WAY_LIST_LOADING:
			return { ...state, isCollectionWayListLoading: [...state.isCollectionWayListLoading, action.payload] };
		case RESET_IS_COLLECTION_WAY_LIST_LOADING:
			return {
				...state,
				isCollectionWayListLoading: state.isCollectionWayListLoading.filter(el => el !== action.payload),
			};
		case SET_ORDERS_COLLECTION_GROUP_LIST:
			return {
				...state,
				ordersCollectionGroupList: payload,
			};
		case SET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING:
			return {
				...state,
				isOrdersCollectionGroupListLoading: [...state.isOrdersCollectionGroupListLoading, action.payload],
			};
		case RESET_IS_ORDERS_COLLECTION_GROUP_LIST_LOADING:
			return {
				...state,
				isOrdersCollectionGroupListLoading: state.isOrdersCollectionGroupListLoading.filter(
					el => el !== action.payload,
				),
			};
		case SET_ORDERS_COLLECTION_WAY_LIST:
			return {
				...state,
				ordersCollectionWayList: payload,
			};
		case SET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING:
			return {
				...state,
				isOrdersCollectionWayListLoading: [...state.isOrdersCollectionWayListLoading, action.payload],
			};
		case RESET_IS_ORDERS_COLLECTION_WAY_LIST_LOADING:
			return {
				...state,
				isOrdersCollectionWayListLoading: state.isOrdersCollectionWayListLoading.filter(
					el => el !== action.payload,
				),
			};
		case SET_WAYS_GROUP_LIST:
			return {
				...state,
				waysGroupList: payload,
			};
		case SET_IS_WAYS_GROUP_LIST_LOADING:
			return { ...state, isWaysGroupListLoading: [...state.isWaysGroupListLoading, action.payload] };
		case RESET_IS_WAYS_GROUP_LIST_LOADING:
			return {
				...state,
				isWaysGroupListLoading: state.isWaysGroupListLoading.filter(el => el !== action.payload),
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_IS_LOADING:
			return {
				...state,
				isLoading: payload,
			};
		case SET_GROUP_OPEN:
			return {
				...state,
				groupOpen: payload,
			};
		case SET_COLLECTION_GROUP_OPEN:
			return {
				...state,
				collectionGroupOpen: payload,
			};
		case SET_GROUP_WAY_OPEN:
			return {
				...state,
				groupWayOpen: payload,
			};
		case SET_WAY_OPEN:
			return {
				...state,
				wayOpen: payload,
			};
		case SET_COLLECTION_WAY_OPEN:
			return {
				...state,
				collectionWayOpen: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default orderGroupsContainerReducer;
